export default "__VITE_ASSET__adf9889a__"